<template>
  <div style="font-weight: 400">
    <div class="ccui-top-title">企业信息</div>
    <el-form ref="addform" :model="form" :rules="rules" label-width="160px">
      <el-form-item label="公司名称：" prop="businessName">
        <!-- <el-input
          clearable
          v-model.trim="form.businessName"
          class="input-long"
          placeholder="请输入公司名称"
          @blur="getBusinessInfo"
          maxlength="50"
        /> -->
        <el-autocomplete
          clearable
          :disabled="isEdit"
          ref="autocomplete"
          v-model.trim="form.businessName"
          :fetch-suggestions="getBusinessInfo"
          class="input-long"
          :trigger-on-focus="false"
          placeholder="请输入公司名称"
          :debounce="500"
          @select="handleSelect"
          @clear="handleClear"
          :maxlength="50"
        >
          <template slot-scope="{ item }">
            <span>{{ item.emVendorInfoBO.vendorNameCn }}</span>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="公司简称：" prop="businessShortname">
        <el-input
          clearable
          v-model.trim="form.businessShortname"
          class="input-long"
          placeholder="请输入公司简称"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="统一社会信用代码：" prop="unifiedCode">
        <el-input
          clearable
          v-model.trim="form.unifiedCode"
          class="input-long"
          placeholder="请输入统一社会信用代码"
          :disabled="true"
        />
      </el-form-item>
      <div class="ccui-top-title">店铺信息</div>
      <!-- 0-品类经营店 1-产家直营店 2-品牌专卖店 3-综合经营店 4-平台自营店 5-扶贫直销店 6-二级集采店 7-云租店铺 8-物流店铺 -->
      <el-form-item label="店铺类型：" prop="shopType">
        <el-radio-group v-model="form.shopType">
          <el-radio :label="8" v-if="orderPurchaseType == 9"
            >物流专营店</el-radio
          >
          <el-radio :label="7" v-else-if="orderPurchaseType == 8"
            >租赁专卖店</el-radio
          >
          <el-radio :label="6" v-else-if="orderPurchaseType == 10"
            >二级集采店</el-radio
          >
          <el-radio :label="9" v-else-if="orderPurchaseType == 11"
            >仓储专卖店</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item
        label="承运商类型："
        prop="shopSupplierSubcategoryBOList"
        v-if="orderPurchaseType == 9"
      >
        <el-select
          v-model="form.shopSupplierSubcategoryBOList"
          placeholder="请选择"
          value-key="subcategoryCode"
          multiple
          collapse-tags
          style="width: 250px;"
          @change="handleChangeShopSupplierSubcategoryBOList"
        >
          <el-option
            v-for="item in carriersTypeOptions"
            :key="item.subcategoryCode"
            :label="item.subcategoryName"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="是否内贸单位："
        prop="isDomesticTrade"
        v-if="orderPurchaseType == 10"
      >
        <el-radio-group v-model="form.isDomesticTrade">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否内部单位：" prop="isInternalUnit" v-else>
        <el-radio-group v-model="form.isInternalUnit">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="店铺名称：" prop="shopName">
        <el-input
          clearable
          v-model.trim="form.shopName"
          :disabled="isEdit"
          class="input-long"
          :placeholder="`xxxx${getShopName(orderPurchaseType)}（xxxx填写单位简称）`"
          maxlength="50"
        />
        <div class="ccui-tip" style="color: #9b9b9b">
          命名形式：以“xxxx{{ getShopName(orderPurchaseType) }}"命名（xxxx填写单位简称）
          <!-- 以“xxxx{{getShopName(orderPurchaseType)}}"命名，命名形式:xxxx专卖店 -->
        </div>
      </el-form-item>
      <el-form-item label="店铺LOGO：" prop="uploadId">
        <fileUpload
          @success="uploadLogo"
          type="LOGO"
          action="/apis/sra/reg/users/signup/uploadFileToOssByShopLoGo"
          :size="[105, 44]"
          :accept="['.png']"
          :fileSize="2"
          ref="logoUploadRef"
        >
          <span slot="tip">尺寸：105px*44px，文件格式：png，大小不超过2M</span>
        </fileUpload>
      </el-form-item>
      <!-- 主营区域和货物类型 提示 -->
      <el-form-item
        style="margin-bottom: 0"
        label=""
        prop=""
        label-width="95px"
        v-if="orderPurchaseType == 9"
      >
        <div
          style="
            background-color: #facd91;
            width: 611px;
            font-weight: 400;
            font-style: normal;
            font-size: 13px;
            letter-spacing: normal;
            color: #333333;
            padding: 5px;
            margin-bottom: 2px;
            line-height: 20px;
          "
        >
          <!-- 提示：填写主营区域和货物类型后，您可关注中交物流服务号并绑定账号，中交物流服务号会根据您填写的主营区域和货物类型为您推送标讯。点击
          <span @click="goToView" style="color: #8080ff; cursor: pointer"
            >查看操作手册</span
          >。 -->
          提示：填写主营区域和货物类型后，关注中交物流服务号
          <span @click="goToView" style="color: #8080ff; cursor: pointer"
            >(点击查看操作指引)</span
          >，为您推送相关区域和货物的标讯。
        </div>
      </el-form-item>

      <!--      新增的东西-->
      <el-form-item
        label="经营类目："
        v-if="orderPurchaseType == 10"
        prop="categoryData"
      >
        <el-checkbox
          style="opacity: 0; position: absolute"
          v-model.trim="form.categoryData"
        ></el-checkbox>
        <div class="category-input-wrapper">
          <div
            :class="
              categoryData[0].categoryName !== '请选择经营类目'
                ? 'category selectClass'
                : 'category'
            "
          >
            <div v-for="(item, idx) in categoryData" :key="idx">
              {{ item.categoryName }}
            </div>
          </div>
          <el-button
            size="mini"
            type="primary-font-mini"
            @click="selectCategoryClick"
            >选择类目</el-button
          >
        </div>
      </el-form-item>

      <el-form-item
        label="主营区域："
        prop="levelCode"
        v-if="orderPurchaseType == 9"
      >
        <!-- <el-radio v-model="form.levelCode" :label="0">全国</el-radio>
        <el-radio v-model="form.levelCode" :label="1">指定区域</el-radio> -->
        <el-select
          v-if="form.levelCode == 1"
          clearable
          readonly
          v-model.trim="mainAreaValue"
          placeholder="请选择区域"
          maxlength="120"
          @focus="$refs.mainArea.init(shopBusinessAreaScopeBOS)"
        >
        </el-select>

        <div
          v-if="form.levelCode == 1"
          style="max-width: 700px;max-height: 140px;overflow: auto;"
        >
          <el-tag
            style="margin-right: 2px; margin-top: 2px"
            :key="index"
            v-for="(tag, index) in shopBusinessAreaScopeBOS"
            closable
            :disable-transitions="false"
            @close="handleClose(index)"
          >
            {{ tag.areaName + tag.provinceName + tag.cityName }}
          </el-tag>
        </div>
      </el-form-item>
      <el-form-item
        label="货物类型："
        prop="shopBusinessCategoryScopeBOS"
        v-if="orderPurchaseType == 9"
      >
        <chooseMaterialDirectory
          ref="chooseMaterialRef"
          :value.sync="form.shopBusinessCategoryScopeBOS"
          @reValidatorShopBusinessCategoryScopeBOS="
            reValidatorShopBusinessCategoryScopeBOS
          "
        />
      </el-form-item>

      <el-form-item
        label="店铺经营地址："
        prop="shopAddress"
        v-if="orderPurchaseType == 9"
      >
        <el-input
          type="textarea"
          show-word-limit
          clearable
          readonly
          v-model.trim="form.shopAddress"
          class="input-long"
          placeholder="请选择店铺经营地址"
          maxlength="120"
          @focus="$refs.concAddress.init()"
        />
      </el-form-item>
      <el-form-item label="店铺经营地址：" v-else>
        <el-input
          clearable
          v-model.trim="form.shopAddress"
          class="input-long"
          placeholder="请输入店铺经营地址"
          maxlength="100"
        />
      </el-form-item>
      <el-form-item label="客服电话：" prop="supportPhone">
        <el-input
          clearable
          v-input.mobileCN
          v-model.trim="form.supportPhone"
          class="input-long"
          placeholder="请输入客服电话"
          maxlength="30"
        />
      </el-form-item>
      <el-form-item label="店铺简介：" prop="shopBrief">
        <el-input
          maxlength="500"
          clearable
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6 }"
          class="input-long"
          placeholder="请输入"
          v-model.trim="form.shopBrief"
        />
      </el-form-item>
      <template v-if="orderPurchaseType != 9">
        <div class="ccui-top-title">注册联系人</div>
        <el-form-item label="姓名：" prop="contactName">
          <el-input
            clearable
            v-model.trim="form.contactName"
            class="input-long"
            placeholder="请输入姓名"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <div style="display: flex; align-items: center">
            <el-input
              clearable
              v-model.trim="form.phone"
              class="input-long"
              placeholder="请输入手机号"
              maxlength="11"
            />

            <div
              style="font-family: PingFangSC"
              :class="
                isPhoneBtnClick
                  ? 'phoneBtn phoneBtn-click'
                  : 'phoneBtn phoneBtn-default'
              "
              @click="getTestCode"
            >
              {{ isPhoneBtnClick ? phoneBtnTxt + "秒" : phoneBtnTxt }}

              <div class="islider" v-if="isCode">
                <Slider
                  @close="isCode = false"
                  :log="true"
                  @getImg="getImg"
                  @validImg="validImg"
                ></Slider>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="验证码：" prop="authCode">
          <el-input
            clearable
            v-model.trim="form.authCode"
            class="input-long"
            placeholder="请输入验证码"
            maxlength="8"
          />
        </el-form-item>
      </template>
      <div class="ccui-top-title">上传材料</div>
      <el-form-item label="授权委托书：" prop="isfileBos">
        <el-input v-model="form.isfileBos" v-show="false"></el-input>
        <fileUpload
          @success="uploadSuccess"
          :limit="1"
          ref="fileUploadRef"
        ></fileUpload>
      </el-form-item>
      <el-form-item
        label="承运商合作框架协议："
        prop="isXYfileBos"
        v-if="orderPurchaseType == 9"
      >
        <el-input v-model="form.isXYfileBos" v-show="false"></el-input>
        <fileUpload
          @success="XYuploadSuccess"
          :limit="1"
          ref="XYfileUploadRef"
          :accept="xyFlieType"
        >
          <span slot="tip"
            >上传电子签约后协议文件或加盖公司公章的合作框架协议扫描件。文件支持格式为：.pdf，文件不超过15MB。</span
          >
        </fileUpload>
      </el-form-item>
      <template v-if="orderPurchaseType == 9">
        <div class="ccui-top-title">业绩证明</div>
        <el-form-item label="" prop="" class="performance_certificate">
          <attachmentUpload
            ref="performanceCertificateRef"
            style="width: 800px"
          ></attachmentUpload>
        </el-form-item>
        <div class="ccui-top-title">意向合作单位</div>
        <el-form-item label="" prop="" class="performance_certificate">
          <div
            class="ccui-multifunctional-table-wrapper ccui-multifunctional-table-wrapper-detail"
            style="width: 800px"
          >
          <span style="color: red; font-size: 14px;"
            >备注：添加的意向合作单位存在上下级机构关系时，只保留上级单位</span
          >
            <div class="operate">
              <el-button plain type="single-number" @click="addLine()"
                >新增</el-button
              >
            </div>
            <el-table
              :data="intentionUnitTableData"
              border
              class="dic-sub-table-style01"
            >
              <el-table-column type="index" label="序号" width="50" />
              <el-table-column
                prop="intendedUnitName"
                label="意向合作单位"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column type="action" label="操作" width="130">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="deleteRow(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <staffSelector
              ref="choosePartyA"
              selectedTitle="已选择单位"
              :isOverseas="isOverseas"
              title="请选择单位"
              mode="radio"
              :requestTreeFunction="queryRecommendedUnitTree"
              :requestSeachFunction="queryMemberGroup"
              @selectedStaffSuccess="selectPartyA"
            >
            </staffSelector>
          </div>
        </el-form-item>
      </template>
    </el-form>
    <!-- 合同履约地址 -->
    <concAddress ref="concAddress" :detail="form" @ok="handleSelectAddress" />
    <!-- 选择主营区域 -->
    <mainArea
      ref="mainArea"
      :detail="form"
      @selectMainArea="handleSelectMainAreaAddressNew"
    />
    <el-dialog
      class="dialog-center"
      title="提示"
      :visible.sync="tipDialogVisible"
      :show-close="false"
      width="400px"
      show-divider
      show-shadow
      custom-class="el-dialog--customize"
    >
      <div style="text-indent: 2em">
        您当前的账号未开通租赁商身份，无法申请开通租赁店铺！
        <span style="font-weight: bold"
          >请前往 【客户关系管理】→【信息维护】→【注册资料变更】
          在供应商类型中，新增并勾选 【租赁商】</span
        >
        提交审核通过后可开通租赁店铺。
      </div>
      <span slot="footer" style="text-align: center">
        <el-button size="mini" @click="tipDialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="tipDialogVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>

    <!--新增的东西-->
    <dialog-multi-checkbox-group
      ref="categoryData"
      :shopId="resultInfo.shopId"
      :shopInfo="shopInfo"
      :defaultPitchOn="defaultPitchOn"
      :agentId="agentId"
      :headers="headers"
      :dialogVisible.sync="dialogVisible"
      :shopType="form.shopType"
      @determine="determine"
      @refdata="refdata"
      :qryCategoryByCodeUrl="qryCategoryByCodeUrl"
      :qryFirstCategoryUrl="qryFirstCategoryUrl"
    ></dialog-multi-checkbox-group>
  </div>
</template>

<script>
import fileUpload from "./fileUpload.vue";
import validators from "@/utils/validators";
import { getSendMsg, getImageVerifyCode } from "@/api/register-shop";
import concAddress from "./concAddress";
import staffSelector from "./staffSelector.vue";

import chooseMaterialDirectory from "./chooseMaterialDirectory";
// import mainArea from "./mainArea";
import mainArea from "@/views/lessor-open-shop/components/chackAddress.vue";
import DialogMultiCheckboxGroup from "./dialog-multi-checkbox-group-Two.vue";
import attachmentUpload from "./attachmentUpload.vue";
// import cooperativeUnit from "./cooperativeUnit.vue";
import {
  qrySupInfoListItem,
  queryAddShopInfo,
  getUserInfo,
  queryCooperativeRelationshipList
} from "@/api/lessor-open-shop.js";
import Slider from "@/views/common/slider.vue";
import Cookies from "js-cookie";
import {
  queryRecommendedUnitTree,
  queryMemberGroup
} from "@/api/intentionUnit";
export default {
  components: {
    fileUpload,
    Slider,
    concAddress,
    mainArea,
    chooseMaterialDirectory,
    DialogMultiCheckboxGroup,
    attachmentUpload,
    // cooperativeUnit,
    staffSelector
  },
  data() {
    let baseUrl = this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    return {
      isOverseas: 0,
      intentionUnitTableData: [],
      isEdit: false,
      mainAreaValue: "",
      shopBusinessAreaScopeBOS: [], //主营区域
      xyFlieType: [".pdf"], //承运商合作框架协议
      zLSupFlag: true, //是否是租赁商身份标识
      phoneBtnTxt: "发送验证码",
      isPhoneBtnClick: false,
      tipDialogVisible: false,
      isCode: false,
      form: {
        businessName: "", //公司名称
        businessShortname: "", //公司简称
        unifiedCode: "", //统一社会信用代码
        shopType: "", //店铺类型
        shopName: "", //店铺名称
        shopLogoUrl: "", //店铺LOGO
        shopAddress: "", //店铺经营地址
        supportPhone: "", //客服电话
        shopBrief: "", //店铺简介
        contactName: "", //注册联系人姓名
        phone: "", //注册联系人手机号
        authCode: "", //验证码
        fileBos: [], //授权委托书
        agreementFileBos: [], //承运商合作框架协议
        isInternalUnit: 0, //是否内部单位  0-否 1-是
        isDomesticTrade: 0, //是否内贸单位  0-否 1-是
        isfileBos: "", //授权委托书
        isXYfileBos: "", //承运商合作框架协议
        deliveryPoints: "",
        levelCode: 1, //主营区域
        shopSupplierSubcategoryBOList: [] //承运商类型
      },
      phoneInfo: {},
      canEdit: true,
      rules: {
        businessName: [
          { required: true, message: "请输入公司名称", trigger: "change" }
        ],
        businessShortname: [
          { required: true, message: "请输入公司简称", trigger: "change" }
        ],
        shopBrief: [
          { required: false, message: "请输入店铺简介", trigger: "change" }
        ],
        isfileBos: [
          { required: true, message: "请上传授权委托书", trigger: "change" }
        ],
        isXYfileBos: [
          {
            required: true,
            message: "请上传承运商合作框架协议",
            trigger: "change"
          }
        ],
        unifiedCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change"
          }
          //   {
          //     pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
          //     message: "请输入正确的统一社会信用代码",
          //     trigger: "change",
          //   },
          //   {
          //     max: 18,
          //     min: 18,
          //     message: "请输入正确的统一社会信用代码",
          //     trigger: "change",
          //   },
        ],
        shopType: [
          { required: true, message: "请选择店铺类型", trigger: "change" }
        ],
        shopSupplierSubcategoryBOList: [
          { required: true, message: "请选择承运商类型", trigger: "change" }
        ],
        shopName: [
          { required: true, message: "请输入店铺名称", trigger: "change" }
        ],
        shopAddress: [
          {
            required: () => this.orderPurchaseType == 9,
            message: "请选择店铺经营地址",
            trigger: "change"
          }
        ],

        contactName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
          {
            // pattern: /^[\u4e00-\u9fa5A-Za-z\s\·\(\)\（\）]+$/,
            // message: '请正确填写姓名',
            pattern: /^((?!.*(&)).)*$/,
            message: "不可输入&",
            trigger: "change"
          }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "change" },
          {
            validator: validators.mobile,
            message: "请输入正确格式的手机号码",
            trigger: "change"
          }
        ],
        levelCode: [
          { required: true, message: "请选择主营区域", trigger: "change" }
        ],
        shopBusinessCategoryScopeBOS: [
          { required: true, message: "请选择货物类型", trigger: "change" }
        ],
        authCode: [
          { required: true, message: "请输入验证码", trigger: "change" }
        ]
      },
      olist: [
        {
          orderPurchaseType: 8,
          name: "租赁专卖店",
          sname: "租赁专卖店",
          shopType: 7
        },
        {
          orderPurchaseType: 9,
          name: "物流专营店",
          sname: "物流专营店",
          shopType: 8
        },
        {
          orderPurchaseType: 10,
          name: "二级集采店",
          sname: "集采店",
          shopType: 6
        },
        {
          orderPurchaseType: 11,
          name: "仓储专卖店",
          sname: "仓储专卖店",
          shopType: 9
        }
      ],
      // 承运商类型
      carriersTypeOptions: [
        { subcategoryCode: "0", subcategoryName: "公路承运人" },
        { subcategoryCode: "1", subcategoryName: "水运承运人" },
        { subcategoryCode: "2", subcategoryName: "无车承运人(网络货运)" },
        { subcategoryCode: "3", subcategoryName: "无船承运人(网络货运)" },
        { subcategoryCode: "4", subcategoryName: "国际货运代理" },
        { subcategoryCode: "5", subcategoryName: "多式联运" },
        { subcategoryCode: "6", subcategoryName: "铁路承运人" },
        { subcategoryCode: "7", subcategoryName: "航空承运人" },
        { subcategoryCode: "8", subcategoryName: "其他" }
      ],

      // 经营类目
      shopInfo: {},
      defaultPitchOn: [],
      categoryData: [{ categoryName: "请选择经营类目" }],
      agentId: "100020",
      headers: {
        APP_TOKEN: Cookies.get("appToken") || ""
      },
      dialogVisible: false,
      //二级目录的数据接口
      qryCategoryByCodeUrl:
        baseUrl + "/apis/sra/store/users/signup/qryCategoryByCode",
      //一级目录的数据接口
      qryFirstCategoryUrl:
        baseUrl + "/apis/sra/store/users/signup/qryFirstCategory",
      selectData: [],
      mockData: [],
      isAll: 0,
      classifyBos: [], //商品类目保存code
      categoryBos: []
    };
  },
  computed: {
    orderPurchaseType() {
      const aa = this.$route.query.orderPurchaseType || 8;
      const bb = this.olist.find(item => item.orderPurchaseType == aa);
      this.form.shopType = bb.shopType;
      return aa;
    },
    resultInfo() {
      return this.$store.state.app.resultInfo;
    }
  },
  methods: {
    queryRecommendedUnitTree,
    queryMemberGroup,
    handleChangeShopSupplierSubcategoryBOList(val) {
      console.log(this.form.shopSupplierSubcategoryBOList, "1111");
      let flag =
        this.form.shopSupplierSubcategoryBOList.filter(
          item => item.subcategoryCode == 4
        ).length > 0;
      console.log(flag, "flag");
      if (!flag) {
        // 承运商类型选择“国际货运代理”时，主营区域数据清空
        this.shopBusinessAreaScopeBOS = [];
      }
    },

    addLine() {
      this.$refs.choosePartyA.selected = [];
      this.$refs.choosePartyA.showDialogInventory();
    },
    deleteRow(index, row) {
      this.intentionUnitTableData.splice(index, 1);
    },
    // 单选
    selectPartyA(data) {
      console.log(data[0], 1010101010);
      if (!data || data.length === 0) return;
      data.forEach(item => {
        this.$set(item, "intendedUnitName", item.companyName);
        this.$set(item, "intendedUnitOrgId", item.companyId);
        this.$set(item, "intendedUnitAutoCode", item.autoCode);
      });
      const newItem = data[0];
      const existingItem = this.intentionUnitTableData.find(
        item => item.companyId === newItem.companyId
      );

      if (existingItem) {
        this.$message({
          message: "该单位已添加，请勿重复选择",
          type: "warning",
          showClose: true,
          offset: document.documentElement.clientHeight / 2 - 21
        });
        return;
      }
      // 最多添加五条
      // if (this.intentionUnitTableData.length >= 5) {
      //   return this.$message({
      //     message: "最多添加五条",
      //     type: "warning",
      //     showClose: true,
      //     offset: document.documentElement.clientHeight / 2 - 21
      //   });
      // }
      this.intentionUnitTableData.push(data[0]);
    },
    // 多选
    // selectPartyA(data) {
    //   console.log(data[0], 1010101010);
    //   if (!data || data.length === 0) return;
    //   data.forEach(item => {
    //     this.$set(item, "intendedUnitName", item.companyName);
    //     this.$set(item, "intendedUnitOrgId", item.companyId);
    //     this.$set(item, "intendedUnitAutoCode", item.autoCode);
    //   });
    //   // 使用Map以intendedUnitOrgId为键进行去重
    //   const map = new Map();
    //   const allData = [...this.intentionUnitTableData, ...data];

    //   // 最多添加五条
    //   if (allData.length > 5) {
    //     return this.$message.warning("最多添加五条");
    //   }
    //   allData.forEach(item => {
    //     if (!map.has(item.intendedUnitOrgId)) {
    //       map.set(item.intendedUnitOrgId, item);
    //     }
    //   });

    //   this.intentionUnitTableData = Array.from(map.values());
    // },
    reValidatorShopBusinessCategoryScopeBOS() {
      this.$refs.addform.validateField("shopBusinessCategoryScopeBOS");
    },
    goToView() {
      window.open("https://kdocs.cn/l/ckLkcgYVUn7z", "_blank");
    },
    getShopName(orderPurchaseType) {
      const cc = this.olist.find(
        item => item.orderPurchaseType == orderPurchaseType
      );
      return cc.sname;
    },
    getMoRenBusinessName() {
      const mName = this.$route.query.supName || "";
      const urlId = this.$route.query.id || "";
      if (urlId) {
        this.getDetailByUrlId(urlId);
      } else {
        this.form.businessName = mName;
        this.$nextTick(() => {
          this.$refs.autocomplete.focus();
          this.$refs.autocomplete.handleChange(mName);
        }, 1000);
        getUserInfo().then(res => {
          if (res.data.code == 0) {
            this.form.contactName = res.data.data.userInfo.name;
            // this.form.phone = res.data.data.userInfo.mobile;
            if (!mName && res.data.data.umOrganizations.length > 1) {
              this.$message({
                showClose: true,
                type: "error",
                message: "有多个兼职单位，请手动输入公司名称",
                ccuiCustom: true
              });
            } else if (
              this.orderPurchaseType == 11 &&
              res.data.data.umOrganizations.length == 1
            ) {
              // 云仓回显公司名称
              this.form.businessName = res.data.data.umOrganizations[0].orgName;
              // this.getBusinessInfo(res.data.data.umOrganizations[0].orgName);
              this.$refs.autocomplete.handleChange(this.form.businessName);
            }
          }
        });
      }
    },
    //新需求 ，url的id 查详情
    getDetailByUrlId(id) {
      queryAddShopInfo({ id: id, isShowLoading: true }).then(res => {
        if (res.data.code == 0) {
          const da = res.data.data;
          for (const key in this.form) {
            this.form[key] = da[key];
          }
          if (da.shopLogoUrl) {
            this.$refs.logoUploadRef.setFileList([
              {
                fileName: "logo.png",
                downloadUrl: da.shopLogoUrl,
                uploadId: da.shopLogoUploadId
              }
            ]);
          }
          if (da.fileAddress) {
            this.$refs.fileUploadRef.setFileList([
              {
                fileName: da.fileName,
                downloadUrl: da.fileAddress,
                uploadId: da.uploadId
              }
            ]);
            this.form.fileBos = [
              {
                fileName: da.fileName, //资质名称
                uploadId: da.uploadId, //上传文件id
                // uploadTime: da.uploadTime, //上传时间
                isLongValidity: 1, //是否长期有效: 0-否 1-是
                isDefault: 1 //是否默认: 0-否 1-是
              }
            ];
            this.form.isfileBos = 1;
          }
          this.$nextTick(() => {
            this.$refs.autocomplete.focus();
            this.$refs.autocomplete.handleChange(this.form.businessName);
          }, 1000);
        }
      });
    },

    handleSelect(item) {
      const info = item.emVendorInfoBO;
      this.form.businessName = info.vendorNameCn;
      this.form.businessShortname = info.vendorSortName;
      this.form.unifiedCode = info.unifySocialCreditCodes;

      //您当前的账号未开通租赁商身份，无法申请开通租赁店铺！
      this.zLSupFlag = info.isZLSup ? true : false;
      //提示框显示-租赁开点查询结果为： 时展示提示框
      if (this.orderPurchaseType == 8 && !this.zLSupFlag) {
        this.tipDialogVisible = true;
      }
      // 物流-获取意向合作关系列表数据
      if (this.orderPurchaseType == 9) {
        this.queryCooperativeRelationshipList(info.vendorNameCn);
      }
    },
    // 物流-获取意向合作关系列表数据
    queryCooperativeRelationshipList(supName) {
      queryCooperativeRelationshipList({ supName: supName }).then(res => {
        console.log(res.data, "queryCooperativeRelationshipList");
        this.intentionUnitTableData = res.data.data.rows.map(item => {
          return {
            intendedUnitName: item.companyName,
            intendedUnitOrgId: item.companyId,
            intendedUnitAutoCode: item.autoCode
          };
        });
      });
    },
    handleClear() {
      this.form.businessShortname = "";
      this.form.unifiedCode = "";
    },
    handleClose(index) {
      this.shopBusinessAreaScopeBOS.splice(index, 1);
    },
    handleSelectMainAreaAddress(val) {
      console.log("handleSelectMainAreaAddress", val);
      console.log("mainAreaValue", this.mainAreaValue);
      let mainAreaLabel = this.shopBusinessAreaScopeBOS.map(
        item => item.areaName + item.provinceName + item.cityName
      );
      let label =
        val.deliveryAreaName + "地区" + val.provinceName + val.cityName;
      console.log("mainAreaLabel", mainAreaLabel);
      console.log("label", label);

      if (mainAreaLabel.indexOf(label) > -1) {
        this.$message.error("该地区已选择");
        return;
      }
      if (val.deliveryAreaCode || val.province || val.city) {
        this.shopBusinessAreaScopeBOS.push({
          areaName: val.deliveryAreaName + "地区",
          areaId: val.deliveryAreaCode,
          provinceName: val.provinceName || "",
          provinceId: val.province || "",
          cityName: val.cityName || "",
          cityId: val.city || ""
        });
      }
      console.log("shopBusinessAreaScopeBOS", this.shopBusinessAreaScopeBOS);

      // this.form.areaName = val.deliveryAreaName;
      // this.form.areaId = val.deliveryAreaCode;
      // this.form.provinceName = val.provinceName;
      // this.form.provinceId = val.province;
      // this.form.cityName = val.cityName;
      // this.form.cityId = val.city;
      // this.form.countyName = val.countyName;
      // this.form.countyId = val.county;
      // this.form.deliveryPoints = val.deliveryPoints;
      // this.form.shopAddress =
      //   val.deliveryAreaName +
      //   val.provinceName +
      //   val.cityName +
      //   val.countyName +
      //   val.deliveryPoints;
    },
    handleSelectMainAreaAddressNew(list) {
      const re = list.map(val => {
        return {
          areaName: val.deliveryAreaName,
          areaId: val.deliveryAreaCode,
          provinceName: val.provinceName || "",
          provinceId: val.province || "",
          cityName: val.cityName || "",
          cityId: val.city || ""
        };
      });

      this.shopBusinessAreaScopeBOS = re;
    },
    handleSelectAddress(val) {
      console.log("handleSelectAddress", val);
      // this.form.countryName = "中国";
      // this.form.countryId = "142";
      this.form.areaName = val.deliveryAreaName;
      this.form.areaId = val.deliveryAreaCode;
      this.form.provinceName = val.provinceName;
      this.form.provinceId = val.province;
      this.form.cityName = val.cityName;
      this.form.cityId = val.city;
      this.form.countyName = val.countyName;
      this.form.countyId = val.county;
      this.form.deliveryPoints = val.deliveryPoints;
      // this.form.town = "";
      // this.form.townId = "";
      this.form.shopAddress =
        val.deliveryAreaName +
        val.provinceName +
        val.cityName +
        val.countyName +
        val.deliveryPoints;
    },
    getBusinessInfo(queryString, cb) {
      if (!queryString) {
        return cb([]);
      }
      this.handleClear();
      qrySupInfoListItem({
        supName: queryString,
        pageSize: 200
      })
        .then(res => {
          if (res.data.code == 0) {
            const list = res.data.data || [];
            if (list.length > 0) {
              if (list.length == 1) {
                this.handleSelect(list[0]);
                this.$refs.autocomplete.blur();
                if (this.orderPurchaseType == 9) {
                  // 物流-获取意向合作关系列表数据
                  this.queryCooperativeRelationshipList(info.vendorNameCn);
                }
              } else {
                const results = list.map(el => {
                  el.businessName = el.emVendorInfoBO.vendorNameCn;
                  return el;
                });
                // 按匹配度排序
                results.sort((a, b) => {
                  const aIndex = a.businessName
                    .toLowerCase()
                    .indexOf(queryString.toLowerCase());
                  const bIndex = b.businessName
                    .toLowerCase()
                    .indexOf(queryString.toLowerCase());
                  return aIndex - bIndex;
                });
                cb(results);
              }
            } else {
              this.handleClear();
              this.$message({
                showClose: true,
                type: "error",
                message: "请确认公司名称是否正确，是否已完成统一入网认证",
                ccuiCustom: true
              });
              return cb([]);
            }
          }
        })
        .catch(err => {
          return cb([]);
        });
    },

    uploadLogo(fileList) {
      if (fileList.length > 0) {
        this.form.shopLogoUrl = fileList[0].downloadUrl;
        this.form.uploadId = fileList[0].uploadId;
      } else {
        this.form.shopLogoUrl = "";
        this.form.uploadId = "";
      }
    },
    uploadSuccess(fileList) {
      this.form.fileBos = fileList.map(el => {
        return {
          fileName: el.fileName, //资质名称
          uploadId: el.uploadId, //上传文件id
          uploadTime: el.uploadTime, //上传时间
          isLongValidity: 1, //是否长期有效: 0-否 1-是
          isDefault: 1 //是否默认: 0-否 1-是
        };
      });
      this.form.isfileBos = this.form.fileBos.length ? 1 : "";
    },
    XYuploadSuccess(fileList) {
      this.form.agreementFileBos = fileList.map(el => {
        return {
          fileName: el.fileName, //资质名称
          uploadId: el.uploadId, //上传文件id
          uploadTime: el.uploadTime, //上传时间
          isLongValidity: 1, //是否长期有效: 0-否 1-是
          isDefault: 1 //是否默认: 0-否 1-是
        };
      });
      this.form.isXYfileBos = this.form.agreementFileBos.length ? 1 : "";
    },
    phoneBtnClick(blcokLeft, id, callback) {
      this.getCode(blcokLeft, id, callback);
    },
    getCode(blcokLeft, id, callback) {
      getSendMsg({
        phone: this.form.phone,
        captchaVail: { x: blcokLeft, catuid: id }
      }).then(res => {
        console.log(res, "发送短信验证码接口");
        if (res.data.code == "0") {
          callback({ data: true });
          this.isCode = false;
          this.show = false;
          let timer;
          this.isPhoneBtnClick = true;
          this.phoneBtnTxt = 60;
          timer = setInterval(() => {
            this.phoneBtnTxt = --this.phoneBtnTxt;
            if (!this.phoneBtnTxt) {
              this.isPhoneBtnClick = false;
              this.phoneBtnTxt = "发送验证码";
              clearInterval(timer);
            }
          }, 1000);
        } else {
          callback({ data: false, message: res.data.message });
          this.isCode = true;
          this.show = true;
        }
      });
    },
    // 获取滑动验证码的图片
    getImg(callback) {
      getImageVerifyCode({}).then(
        res => {
          callback(res.data);
        },
        error => {
          callback(error);
        }
      );
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(blcokLeft, id, callback) {
      // blcokLeft,// 手动定位返回的值
      //   id// 后台返回的id，再传回去
      this.phoneBtnClick(blcokLeft, id, callback); // 登陆请求方法
    },
    getTestCode() {
      this.$refs["addform"].validateField("phone", valid => {
        if (!valid) {
          if (!this.isPhoneBtnClick) {
            this.isCode = true;
          }
        }
      });
    },
    rsetShopData() {
      this.isEdit = false;
      this.form = this.$options.data().form;
      this.$refs.logoUploadRef.setFileList([]);
      this.$refs.fileUploadRef.setFileList([]);
      this.$refs.XYfileUploadRef && this.$refs.XYfileUploadRef.setFileList([]);
    },
    setShopInfo(da) {
      this.isEdit = true;
      for (const key in this.form) {
        this.form[key] = da[key];
      }
      if (da.shopLogoUrl) {
        this.$refs.logoUploadRef.setFileList([
          {
            fileName: "logo.png",
            downloadUrl: da.shopLogoUrl,
            uploadId: da.shopLogoUploadId
          }
        ]);
      }
      if (da.shopAptitudeInfoBOS) {
        const fileda = da.shopAptitudeInfoBOS[0];
        this.$refs.fileUploadRef.setFileList([
          {
            fileName: fileda.aptitudeName,
            downloadUrl: fileda.downloadUrl,
            uploadId: fileda.uploadId
          }
        ]);
        this.form.fileBos = [
          {
            fileName: fileda.aptitudeName, //资质名称
            uploadId: fileda.uploadId, //上传文件id
            // uploadTime: da.uploadTime, //上传时间
            isLongValidity: 1, //是否长期有效: 0-否 1-是
            isDefault: 1 //是否默认: 0-否 1-是
          }
        ];
        this.form.isfileBos = 1;
      }
      //承运商合作框架协议
      if (da.shopAgreementFileBOS && da.shopAgreementFileBOS.length > 0) {
        const fileda = da.shopAgreementFileBOS[0];
        this.$refs.XYfileUploadRef.setFileList([
          {
            fileName: fileda.aptitudeName,
            downloadUrl: fileda.downloadUrl,
            uploadId: fileda.uploadId
          }
        ]);
        this.form.agreementFileBos = [
          {
            fileName: fileda.aptitudeName, //资质名称
            uploadId: fileda.uploadId, //上传文件id
            // uploadTime: da.uploadTime, //上传时间
            isLongValidity: 1, //是否长期有效: 0-否 1-是
            isDefault: 1 //是否默认: 0-否 1-是
          }
        ];
        this.form.isXYfileBos = 1;
      }
      this.form.businessId = da.businessId;
      this.form.businessShortname = da.businessInfoBO.businessShortname;
      this.form.unifiedCode = da.businessInfoBO.unifiedCode;

      // this.form.shopBusinessCategoryScopeBOS = da.shopBusinessCategoryScopeBOS;
      this.$refs.chooseMaterialRef.determine(da.shopBusinessCategoryScopeBOS);
      this.form.levelCode = 1; //去掉全国选项默认指定区域
      this.shopBusinessAreaScopeBOS =
        this.form.levelCode == 1 ? da.shopBusinessAreaScopeBOS : [];
      //业绩证明
      this.$refs.performanceCertificateRef.fileTableData =
        da.shopPerformanceCertificationBOList;
      // 意向合作单位
      this.intentionUnitTableData = da.shopIntendedUnitBOList;
    },
    setPhoneInfo(val) {
      this.phoneInfo = val;
      console.log("注册联系人*-*--*--**-", val);
    },

    handleSubmit() {
      return new Promise((resolve, reject) => {
        if (this.orderPurchaseType == 8 && !this.zLSupFlag) {
          this.tipDialogVisible = true;
          reject("您当前的账号未开通租赁商身份，无法申请开通租赁店铺！");
          return;
        }
        this.$refs["addform"].validate(valid => {
          console.log(this.form, "表单");
          const da1 = {
            ...this.form,
            categoryBos: this.selectData,
            shopManagerPhone: this.form.phone,
            shopManager: this.form.contactName,
            shopBusinessAreaScopeBOS: this.form.levelCode
              ? this.shopBusinessAreaScopeBOS
              : []
          };
          if (this.orderPurchaseType == 9) {
            //承运商类型选择“国际货运代理”时，主营区域展示海外的区域选择数据；其它类型承运商，均不展示海外。
            let flag =
              this.form.shopSupplierSubcategoryBOList.filter(
                item => item.subcategoryCode == 4
              ).length > 0;
            console.log(flag, "flag");
            if (!flag) {
              da1.shopBusinessAreaScopeBOS = da1.shopBusinessAreaScopeBOS.filter(
                v => {
                  return v.areaId != "980000";
                }
              );
            }

            // 承运商类型
            da1.shopSupplierSubcategoryBOList = da1.shopSupplierSubcategoryBOList.map(
              item => {
                return {
                  subcategoryName: item.subcategoryName,
                  subcategoryCode: item.subcategoryCode
                };
              }
            );
            // 业绩证明附件数据
            let performanceFileBOS = this.$refs.performanceCertificateRef.fileTableData.map(
              item => {
                delete item.isShowViewBtn;
                delete item.createTime;
                return {
                  ...item
                };
              }
            );
            // 意向合作单位数据
            let selectData = this.intentionUnitTableData.map(item => {
              return {
                intendedUnitOrgId: item.intendedUnitOrgId,
                intendedUnitAutoCode: item.intendedUnitAutoCode,
                intendedUnitName: item.intendedUnitName
              };
            });
            da1.shopPerformanceCertificationBOList = performanceFileBOS; //业绩证明
            da1.shopIntendedUnitBOList = selectData; //意向合作单位
          }
          console.log(da1, "da13333333");
          if (!valid) return reject("表单校验失败");
          if (this.orderPurchaseType == 9) {
            // 主营区域
            if (
              this.form.levelCode == 1 &&
              this.shopBusinessAreaScopeBOS.length == 0
            ) {
              this.$message.error("请选择主营区域");
              return;
            } else if (this.form.levelCode === "") {
              this.$message.error("请选择主营区域");
              return;
            }
          }

          if (this.orderPurchaseType == 10) {
            this.form.isInternalUnit = null;
          } else {
            this.form.isDomesticTrade = null;
          }
          if (this.phoneInfo.phone) {
            this.form = { ...this.form, ...this.phoneInfo };
          }
          console.log(this.form, "表单");

          const da = {
            ...this.form,
            categoryBos: this.selectData,
            shopManagerPhone: this.form.phone,
            shopManager: this.form.contactName,
            shopBusinessAreaScopeBOS: this.form.levelCode
              ? this.shopBusinessAreaScopeBOS
              : []
          };
          // 物流
          if (this.orderPurchaseType == 9) {
            //承运商类型选择“国际货运代理”时，主营区域展示海外的区域选择数据；其它类型承运商，均不展示海外。
            let flag =
              this.form.shopSupplierSubcategoryBOList.filter(
                item => item.subcategoryCode == 4
              ).length > 0;
            console.log(flag, "flag");
            if (!flag) {
              da.shopBusinessAreaScopeBOS = da.shopBusinessAreaScopeBOS.filter(
                v => {
                  return v.areaId != "980000";
                }
              );
            }
            // 承运商类型
            da.shopSupplierSubcategoryBOList = da.shopSupplierSubcategoryBOList.map(
              item => {
                return {
                  subcategoryName: item.subcategoryName,
                  subcategoryCode: item.subcategoryCode
                };
              }
            );
            // 业绩证明附件数据
            let performanceFileBOS = this.$refs.performanceCertificateRef.fileTableData.map(
              fileData => {
                return {
                  fileUrl: fileData.downloadUrl,
                  fileName: fileData.fileName,
                  fileSize: fileData.fileSize,
                  fileSumm: fileData.fileSumm,
                  fileDesc: fileData.fileDesc,
                  uploadTime: fileData.uploadTime,
                  fileinfoType: fileData.fileType,
                  uploadId: fileData.uploadId
                };
              }
            );
            // 意向合作单位数据
            let selectData = this.intentionUnitTableData.map(item => {
              return {
                // id: 8,
                // shopType: 8,
                // shopId: 8,
                intendedUnitOrgId: item.intendedUnitOrgId,
                intendedUnitAutoCode: item.intendedUnitAutoCode,
                intendedUnitName: item.intendedUnitName
                // operName: "",
                // operTime: "",
                // operId: ""
              };
            });
            da.shopPerformanceCertificationBOList = performanceFileBOS; //业绩证明
            da.shopIntendedUnitBOList = selectData; //意向合作单位
          }
          console.log(da, 3333333);
          resolve(da);
        });
      });
    },

    selectCategoryClick() {
      this.dialogVisible = true;
    },
    getCodeList() {
      // 提交时经营类目重组
      let list = [];
      this.defaultPitchOn.map(item1 => {
        if (item1.isSelected === true || item1.isSelected === "1") {
          // 有选中便利下一级
          item1.shopSecondCategoryBOS.map(item2 => {
            if (item2.isSelected === true || item2.isSelected === "1") {
              // 有选中便利下一级
              item2.shopThirdCategoryBOS.map(item3 => {
                if (item3.isSelected === true || item3.isSelected === "1") {
                  // 当前项选中
                  list.push({
                    categoryCode: item3.categoryCode,
                    categoryName: item3.categoryName
                  });
                }
              });
            }
          });
        }
      });
      console.log(list, "最终提交的三级经营编码");
      return list;
    },
    determine(checkArr) {
      this.defaultPitchOn = JSON.parse(JSON.stringify(checkArr));
      console.log(checkArr, "确定选中的数据");
      //选中数据过滤
      this.selectData = [];
      //展示数据用
      this.categoryData = [];

      //递归数据 过滤一下
      this.traverseData(JSON.parse(JSON.stringify(checkArr)));
      //选中的数据进行拼接展示
      if (this.selectData && this.selectData.length > 0) {
        this.selectDataShowFun();
      }
      if (
        this.categoryData &&
        this.categoryData.length > 0 &&
        this.categoryData[0].categoryName !== "请选择经营类目"
      ) {
        this.form.categoryData = "有数据";
        //清除校验
        this.$refs["addform"].clearValidate("categoryData");
      } else {
        this.form.categoryData = ""; //添加校验
        this.$refs["addform"].validateField("categoryData");
      }
    },
    refdata(data) {
      this.mockData = JSON.parse(JSON.stringify(data));
      this.defaultPitchOn = JSON.parse(JSON.stringify(data));
    },
    //递归处理经营类目选中的数据
    traverseData(dataArr) {
      //统计一下有几个一级大类没有二级数据的
      let countData = 0;

      //存在下级数据而且长度大于0 那么继续遍历
      dataArr.forEach(item => {
        //isAll判断是否全选
        //isSelected主要是判断一级和二级是否有选中的下级类目
        if (item.isSelected) {
          //是否全部选中 是1 否0
          if (item.isAll) {
            this.isAll = 1;
          } else {
            this.isAll = 0;
          }
          //选中的数据
          this.selectData.push(item);
          this.selectData = this.transformBooleanToNumber(this.selectData);
        } else {
          countData++;
        }
      });

      //这个是确定是否是没选中数据的情况下  如果不选中如何数据 置空
      if (countData === dataArr.length) {
        console.log("没有选中任何数据");
        //点击确定没选中任何数据
        this.categoryData = [{ categoryName: "请选择经营类目" }];
        //选中数据过滤
        this.selectData = [];
      }
    },
    transformBooleanToNumber(obj) {
      if (Array.isArray(obj)) {
        return obj.map(item => this.transformBooleanToNumber(item));
      } else if (obj !== null && typeof obj === "object") {
        const newObj = {};
        for (const key in obj) {
          if (key === "isAll") {
            newObj[key] = obj[key] ? 1 : 0;
          } else {
            newObj[key] = this.transformBooleanToNumber(obj[key]);
          }
        }
        return newObj;
      }
      return obj;
    },
    //编辑页面页面的数据反显
    dataShowEdit(categoryBosList) {
      this.defaultPitchOn = [];
      this.categoryBos = [];
      this.categoryData = [];
      console.log(categoryBosList);
      categoryBosList.forEach(item1 => {
        item1.isAll = item1.isAll == 1 ? true : false;
      });
      //弹框回显的数据
      let categoryBosList1 = JSON.parse(JSON.stringify(categoryBosList));
      if (categoryBosList.length > 0) {
        console.log("🚀 ~ 1111111111111:", categoryBosList1);
        this.defaultPitchOn = categoryBosList1;
      }

      let arrlistNames = [],
        arrlistcategoryCodes = [],
        arrListChildName = [],
        arrListChildCode = [];
      categoryBosList1.forEach(item => {
        //页面反显展示逻辑
        this.categoryData.push({
          categoryName: item.categoryNames,
          categoryCode: item.categoryCodes
        });

        //下面是弹框的反显展示逻辑
        arrlistNames = item.categoryNames.split(">");
        arrlistcategoryCodes = item.categoryCodes.split(",");

        for (let k = 0; k < arrlistNames.length; k++) {
          //一级和二级目录的name和code
          //第三项开始为三级目录
          if (k >= 2) {
            arrListChildName = arrlistNames[k].split("\\");
            arrListChildCode = arrlistcategoryCodes[k].split("\\");
            for (let s = 0; s < arrListChildName.length; s++) {
              this.categoryBos.push({
                categoryName: arrListChildName[s],
                categoryCode: arrListChildCode[s],
                isAll: item.isAll
              });
            }
          }
        }
      });

      console.log(this.defaultPitchOn, "defaultPitchOn需要弹框反显的数据");
    },
    //经营类目数据的展示处理
    selectDataShowFun() {
      console.log(this.selectData, "过滤后需要展示的数据");
      let objShowData = {};
      this.selectData.forEach(item => {
        //一级展示
        if (
          item.shopSecondCategoryBOS &&
          item.shopSecondCategoryBOS.length > 0
        ) {
          // 二级集采 只展示一级类目
          objShowData = {};
          objShowData.categoryName = item.categoryName;
          this.categoryData.push(objShowData);

          // item.shopSecondCategoryBOS.forEach((item2, index2) => {
          //   objShowData = {};
          //   objShowData.categoryName = item.categoryName + ">";
          //   //二级选中的数据展示
          //   if (item2.isSelected) {
          //     objShowData.categoryName =
          //       objShowData.categoryName + item2.categoryName + ">";

          //     item2.shopThirdCategoryBOS.forEach((item3, ind) => {
          //       //三级选中的数据展示
          //       if (item3.isSelected) {
          //         if (ind === item2.shopThirdCategoryBOS.length - 1) {
          //           objShowData.categoryName =
          //             objShowData.categoryName + item3.categoryName;
          //         } else {
          //           objShowData.categoryName =
          //             objShowData.categoryName + item3.categoryName + "\\";
          //         }
          //       }
          //     });

          //     //二级数据处理完一项然后push进入数组 展示
          //     this.categoryData.push(objShowData);
          //   }
          // });
        }
      });
      console.log(this.categoryData, "过滤完最终需要展示的数据");
    }
  }
};
</script>

<style lang="scss" scoped>
.ccui-top-title {
  margin-bottom: 20px;
}
.phoneBtn {
  border-radius: 4px;
  font-size: 13px;
  width: 85px;
  font-weight: 400;
  color: #fff;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}
.phoneBtn-default {
  background-color: rgba(255, 20, 47, 1);
  &:hover {
    background: #f50b25;
  }
}
.phoneBtn-click {
  background: #cccccc;
  border: 1px solid rgba(204, 204, 204, 1);
  color: #999999;
}
.islider {
  width: 400px;
  height: 265px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px rgba(201, 201, 201, 0.5),
    4px 0px 4px 0px rgba(229, 229, 229, 0.5);
  position: absolute;
  left: 252px;
  top: -280px;
}
.islider::before {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid rgba(0, 0, 0, 0.1);
}
.islider::after {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid #ffffff;
  filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, 0.2));
}
/deep/.el-radio {
  line-height: 30px;
  input[aria-hidden="true"] {
    display: none !important;
  }
}
/deep/.el-tooltip__popper.is-dark.address-tooltip {
  color: #4a4a4aff;
  padding: 8px;
  width: 255px;
  min-height: 64px;
  background: rgba(240, 240, 240, 1);
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  border: 1px solid rgba(218, 218, 218, 1);
}

.category-input-wrapper {
  display: flex;
  .category {
    margin-right: 20px;
    max-height: 146px;
    overflow-y: auto;
    border-radius: 3px;
    box-sizing: border-box;
    width: 410px;
    border: 1px solid #dcdfe6;
    padding: 2px 9px;
    color: #999999;
    font-size: 13px;
    cursor: pointer;
    transition: border-color 0.2s;
    div {
      line-height: 25px;
    }
  }
  .selectClass {
    color: #4a4a4a;
  }
  .category:hover {
    border-color: #999;
  }
}
/deep/.performance_certificate {
  .el-form-item__content {
    margin-left: 0px !important;
  }
}
.operate {
  float: right;
  margin: 0 0 10px 0 !important;
}
/deep/.el-button.el-button--single-number {
  border: 1px solid #ff142f;
  background: #fff;
  span {
    color: #ff142f;
  }
  &:hover {
    border-color: #ff142f;
    background: #ff142f;

    span {
      color: #fff;
    }
  }
}
</style>
